module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DD9a8n/tc-custom/9781528960328.jpg?1705687990015",
      "alt": "This image is the cover for the book The House on Juniper Drive"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The House on Juniper Drive\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The house on Juniper Drive becomes home to an assortment of people who take residence there and impact on the life of Judy Vernon from child to adult. As a rather precocious child, Judy discovers a sixth sense within her. For some reason unbeknown to her there’s a link, a strong connection to this one house. As Judy grows from childhood into adulthood, she feels a great need to one day own the house on Juniper Drive. But as time passes the likelihood of this ever happening seems to be nothing more than a pipedream. An impossibility. But can the impossible really happen and a horror be uncovered?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patsy Barry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Patsy was born as Margaret Stone on the 4th of April. Her due date should have been 17th March, St Patrick’s Day and Patsy was her father’s pet name for her. Patsy was a real Dundee lass. She worked in the office of the local jute mill as a wage clerk. In those days, long before computers, her means of calculating wages and bonuses was with a slide rule. When Patsy, a working mother with 5 children, was finally able to pursue her love of writing, her husband, Andy, proudly presented her with her first laptop.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0